import createConverter from './lib/create_converter';
import User from 'models/user';

export default createConverter(User);
